export const classNamesList = (classNames: Array<string | undefined>) => {
    return classNames.filter(Boolean).join(" ");
};
